import React, { useEffect, useState } from "react";
import {
  Table,
  Badge,
  Dropdown,
  Button,
  Form,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import {
  changeStatusApi,
  deleteSuvicharApi,
  deleteTeamApi,
  deleteUserApi,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import Swal from "sweetalert2";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import { FaPencil } from "react-icons/fa6";
import { BASE_URL } from "../../../services/path";

const TableList = ({
  userData,
  setUser,
  fetchedGetUsers,
  pageLoader,
  handleShowModal,
}) => {
  const notification = useToastContext();

  // ALL STATE
  const [loader, setLoader] = useState(false);

  const handelDelete = async (id) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { id };
          deleteSuvicharApi(requestPayload, notification, (loading, error) => {
            setLoader(loading);

            if (!error) {
              fetchedGetUsers();
            }
          });
        } catch (error) {
          console.error("error:", error);
          setLoader(false);
        }
      }
    });
  };

  console.log("userData", userData);

  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>Suvichar</th>
                <th
                  colSpan={4}
                  style={{
                    width: "377px",
                    textAlign: "center",
                  }}
                >
                  Name
                </th>
                <th>Created</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td style={{ textAlign: "justify" }}>
                          {item?.suvichar}
                        </td>
                        <td
                          colSpan={4}
                          style={{ padding: "10px 20px", width: "377px" }}
                        >
                          {item?.userData?.firstName} &nbsp;
                          {item?.userData?.lastName}
                        </td>
                        <td>{formatDate(item?.createdAt)}</td>
                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center">
                            <Link
                              to=""
                              className="text-black fs-6 px-1"
                              onClick={() => handleShowModal("edit", item)}
                            >
                              <FaPencil />
                            </Link>
                            <Link
                              to=""
                              className="text-danger fs-5 px-1"
                              onClick={() => handelDelete(item?._id)}
                            >
                              <MdDeleteForever />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {/* {userData?.length < 0 && (
          <tbody>
            <tr className="text-center" colspan={7}>
              <td colspan={7}>No Record Found</td>
            </tr>
          </tbody>
        )} */}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default TableList;
